import {texture} from "p3";
import definitions from "../definitions";
import GameScene from "../scenes/GameScene";

export default class NPCStatusIndicator extends PIXI.Container {
    constructor() {
        super();

        this._view = null;
        this._icon = null;

        this._state = definitions.NPC_STATUS_INDICATOR_STATE.QUEST_NONE;

        this._iconPulse = false;
        this._iconPulseTime = 0;
        this._iconPulseFrequency = 8;
        this._iconPulseAmplitude = 0.2;

        this._tween = null;

        this.init();
    }

    init() {
        this._view = new PIXI.Sprite(texture("icon_npc_quest_bubble"));
        this._view.anchor.set(0.5, 1);
        this.addChild(this._view);

        this._icon = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._icon.position.set(0, -55);
        this._icon.anchor.set(0.5);
        this._view.addChild(this._icon);

        this.state = definitions.NPC_STATUS_INDICATOR_STATE.QUEST_NONE;

        this.animateShrink().then();
    }

    update() {
        if (this._iconPulse) {
            const scale = 1 - ((Math.sin(this._iconPulseTime * this._iconPulseFrequency) + 1) / 2) * this._iconPulseAmplitude;
            this._icon.scale.set(scale);
            this._iconPulseTime += window.dt;
        }
    }

    /**
     * @return {Promise}
     */
    animateGrow() {
        return new Promise((resolve) => {
            this.stopAnimation();

            this._tween = GameScene.active.addTween(gsap.to(this._view.scale, 0.34, {
                x: 1.3,
                y: 1.3,
                ease: Back.easeOut,
                onStart: () => {
                    this._iconPulse = true;
                    this._iconPulseTime = 0;
                },
                onComplete: () => {
                    resolve();
                }
            }));
        });
    }

    /**
     * @return {Promise}
     */
    animateShrink() {
        return new Promise((resolve) => {
            this.stopAnimation();

            this._tween = gsap.timeline({ onComplete: resolve });
            this._tween.add(GameScene.active.addTween(gsap.to(this._view.scale, 0.26, {
                x: 1,
                y: 1,
                ease: Back.easeOut
            })), 0);
            this._tween.add(GameScene.active.addTween(gsap.to(this._icon.scale, 0.26, {
                x: 1,
                y: 1,
                ease: Power1.easeInOut
            })), 0);
        });
    }

    stopAnimation() {
        this._iconPulse = false;
        if (this._tween) {
            this._tween.kill();
            this._tween = null;
        }
    }

    /**
     * @return {number}
     */
    get state() {
        return this._state;
    }

    /**
     * @param {number} value
     */
    set state(value) {
        this._state = value;

        let tex;
        switch (value) {
            case definitions.NPC_STATUS_INDICATOR_STATE.QUEST_NONE: {
                tex = PIXI.Texture.EMPTY;
                this.visible = false;
                break;
            }
            case definitions.NPC_STATUS_INDICATOR_STATE.QUEST_AVAILABLE: {
                tex = texture("icon_npc_quest_new");
                this.visible = true;
                break;
            }
            case definitions.NPC_STATUS_INDICATOR_STATE.QUEST_IN_PROGRESS: {
                tex = texture("icon_npc_quest_in_progress");
                this.visible = true;
                break;
            }
            case definitions.NPC_STATUS_INDICATOR_STATE.QUEST_REQUIREMENTS_MET: {
                tex = texture("icon_npc_quest_complete");
                this.visible = true;
                break;
            }
            case definitions.NPC_STATUS_INDICATOR_STATE.QUEST_MINIGAME: {
                tex = texture("icon_npc_game");
                this.visible = true;
                break;
            }
            case definitions.NPC_STATUS_INDICATOR_STATE.QUEST_BOSS_FIGHT: {
                tex = texture("icon_npc_boss");
                this.visible = true;
                break;
            }
        }
        this._icon.texture = tex;
    }
}